// extracted by mini-css-extract-plugin
export default {"content":"success_content__ZDllA","pay":"success_pay__lqA6C"};